export function getElementRect(element: HTMLElement) {
  return {
    left: element.offsetLeft,
    right: element.offsetLeft + element.offsetWidth,
    width: element.offsetWidth,
  };
}
